'use strict';
const angular = require('angular');

export class policiesAndProceduresComponent {

  constructor(DynamicPageService) {
    'ngInject';

    DynamicPageService.getPublicByName({name: "policies-and-procedures"}, page => {
      this.html = page.data;
    }, err => {
    });

  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduuApp.policiesAndProcedures', [])
  .component('policiesAndProcedures', {
    template: require('./policies-and-procedures.component.html'),
    bindings: {
      dismiss: '&'
    },
    controller: policiesAndProceduresComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/policies-and-procedures/policies-and-procedures.component.js